import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import _ from "underscore";

var RosterSelectors = require("lib/selectors/RosterSelectors");
var DataSelectors = require("lib/selectors/DataSelectors");
var DataActions = require("lib/actions/DataActions");

var QuizWidget = require('components/data/widgets/QuizWidget')
var GoalsWidget = require('components/data/widgets/GoalsWidget')
var BookWidget = require('components/data/widgets/BookWidget')
var WritingWidget = require('components/data/widgets/WritingWidget')

var WidgetConfig = require('lib/widgets/WidgetsConfig')
var WidgetItemsConfig = require('lib/widgets/WidgetItemsConfig')

require("data/widgets/widget_container.scss");

@connect(
  (state, props) => {
    var { userID, widgetParams } = props
    // select user from Redux
    if (widgetParams.topLevelDigest == WidgetConfig.STUDENT_ENTITY_TYPE) {
      var user = RosterSelectors.student({ state, id: userID })
    } else {
      var user = RosterSelectors.admin({ state, id: userID })
    }
    var widgets = DataSelectors.widgetDigests({ state: state, entity_type: WidgetConfig.getEntityTypeByUserRole(user.role), entity_id: user.id});
    var nonEmptyWidgets = _.filter(widgets, widget=> !_.isEmpty(widget) && widget.period == "period")
    var showEmptyState = WidgetConfig.showEmptyState(nonEmptyWidgets)
    
    return { user, showEmptyState };
  },

  (dispatch, props) => ({
    populateData: () => {
      var { adminID, topLevelDigest } = props.widgetParams

      var fetchPromises = []

      // fetch admin or student data
      fetchPromises.push(dispatch(DataActions.fetchWidgetDigests({ conditions: { adminID } })))
      // based on type of widget container, we need to pull in additional digests
      if (topLevelDigest == WidgetConfig.STUDENT_ENTITY_TYPE) {
        // we need to make sure the student digests are loaded 
        // student list digests are used for comparisons
        fetchPromises.push(dispatch(DataActions.fetchWidgetDigests({ conditions: { entityType: topLevelDigest, adminID } })))
        fetchPromises.push(dispatch(DataActions.fetchWidgetDigests({ conditions: { entityType: WidgetConfig.STUDENT_LIST_ENTITY_TYPE, adminID } })))
      }
      return Promise.all(fetchPromises);
    },
    fetchDigests: (periodWidgetDigests, user) => {
      var digest = _.first(periodWidgetDigests)

      if (!_.isEmpty(periodWidgetDigests) && !_.isEmpty(digest)) {
        var startDate = digest.start_date
        var endDate = digest.end_date
      } else if (!_.isEmpty(user) && !_.isEmpty(user.expectations_date_spans)) {
        var startDate = user.expectations_date_spans[0].start
        var endDate = user.expectations_date_spans[0].end
      } else {
        // default begining and end of month
        var date = new Date();
        var startDate = new Date(date.getFullYear(), date.getMonth(), 1).toISOString().split('T')[0];
        var endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0).toISOString().split('T')[0];
      }
      return dispatch(DataActions.fetchDigests({ conditions: { startDate, endDate }, cache: true }))
    },
    selectWidgetDigests: (conditions) => {
      // pulls multiple widget digests for situations where we need to pull multiple current widget digests
      // i.e. teacher pulling all current SL widget digests
      return dispatch((dispatch, getState) => {
        return DataSelectors.widgetDigests({ state: getState(), conditions });
      })
    },
    selectStudentList: (id) => {
      return dispatch((dispatch, getState) => {
        return RosterSelectors.studentList({ state: getState(), id });
      })
    },
  })
)

@providePopulateData({ waitForLoad: true })
class WidgetContainer extends React.Component {
  constructor(props) {
    super();
    autobind(this);
    LuckyOrangeClient.tagComponent("WidgetContainer");
  }

  // selects appropriate widget digests based on user role
  getWidgetDigests(currentPeriod) {
    var { user, widgetParams, selectWidgetDigests, selectStudentList } = this.props
    var { period } = widgetParams

    // we pull in period, current, yearly digests for specific widget items
    // (i.e. 'New Quizzes' need current digest)

    var periodConditions = { entity_type: WidgetConfig.getEntityTypeByUserRole(user.role), current_period: true, period}
    var currentConditions = { entity_type: WidgetConfig.getEntityTypeByUserRole(user.role), period: 'current'}
    var yearlyConditions = { entity_type: WidgetConfig.getEntityTypeByUserRole(user.role), current_period: true, period: 'yearly'}

    switch (user.role) {
      // students will pull in their student lists
      // for comparison purposes
      case WidgetConfig.STUDENT_ROLE:
        var slID = user.primary_student_list_id
        var compConditions = { period, entity_id: slID, entity_type: WidgetConfig.STUDENT_LIST_ENTITY_TYPE, current_period: true }
        var compSize = _.size(_.pluck(selectStudentList(slID), 'students'))
        var compScope = 'Class'
        return {
          periodWidgetDigests: selectWidgetDigests({ ...periodConditions, entity_id: user.id }),
          currentWidgetDigests: selectWidgetDigests({ ...currentConditions, entity_id: user.id }),
          compWidgetDigests: selectWidgetDigests({ ...compConditions, entity_id: slID }),
          yearlyWidgetDigests: selectWidgetDigests({ ...yearlyConditions, entity_id: user.id }),
          compSize, compScope
        }
      default:
        return {
          periodWidgetDigests: selectWidgetDigests(periodConditions),
          currentWidgetDigests: selectWidgetDigests(currentConditions),
          yearlyWidgetDigests: selectWidgetDigests(yearlyConditions)
        }
    }
  }

  componentLookup(widget_name) {
    var { user } = this.props
    var widgetDigests = this.getWidgetDigests(true)

    switch (widget_name) {
      case WidgetConfig.QUIZ_WIDGET:
        return <QuizWidget {...widgetDigests} user={user} key={widget_name} showEmptyState={this.props.showEmptyState}/>

      case WidgetConfig.GOALS_WIDGET:
        this.props.fetchDigests(widgetDigests.periodWidgetDigests, user)
        return <GoalsWidget {...widgetDigests} user={user} key={widget_name} showEmptyState={this.props.showEmptyState}/>

      case WidgetConfig.BOOK_WIDGET:
        return <BookWidget {...widgetDigests} user={user} key={widget_name} showEmptyState={this.props.showEmptyState}/>

      case WidgetConfig.WRITING_WIDGET:
        return <WritingWidget {...widgetDigests} user={user} key={widget_name} showEmptyState={this.props.showEmptyState}/>
    }
  }

  renderWidgets() {
    // loop through widgets in user digest
    // render appropriate component
    return _.map(WidgetConfig.getWidgetItemsConfig(this.props.userRole), widget => {
      var key = _.first(_.keys(widget))
      return this.componentLookup(key)
    })
  }

  showEmptyState() {
    // first, filter out comp digests
    var widgetDigests = _.filter(this.getWidgetDigests(false), (v, k) => {
      return k == 'periodWidgetDigests' || k == 'currentWidgetDigests' || k == 'yearlyWidgetDigests'
    })
    
    // then, create array of data hashes from digests
    var widgetDigestData = _.pluck(_.flatten(_.values(widgetDigests)), 'data')
    
    // sums values of all keys that we want to check on the dashboards
    // all must be 0 to show empty state
    var checkValues = _.map(widgetDigestData, (dataHash) => {
      return _.filter(dataHash, (val, key) => {
        return _.includes(WidgetItemsConfig.NON_GOAL_METRICS, key)
      }).reduce((partialSum, a) => partialSum + a, 0)
    })
    
    if (_.isEmpty(widgetDigestData)) {
      // if widget digests don't exist, show empty state
      return true
    } else if (!_.any(checkValues, metric => { return metric > 0 })) {
      // if all metrics are 0, show empty state
      return true
    } else {
      return false
    }
  }

  render() {
    var { user } = this.props

    if (this.props.showEmptyState) {
      var placeholderDisclaimer = <div className={`placeholderDisclaimer`}>Currently displaying placeholder data</div>
    }

    return (
      <div className={`widgetContainer ${WidgetConfig.getEntityTypeByUserRole(user.role)}`}>
        {placeholderDisclaimer}
        <div className={`allWidgets`}>
          {this.renderWidgets()}
        </div>
      </div>
    )
  }
};

WidgetContainer.WrappedComponent.propTypes = PageStrictPropTypes({
  // @connect handlers
  populateData: PropTypes.func,
  user: PropTypes.object,
  selectStudentList: PropTypes.func,
  selectWidgetDigests: PropTypes.func,
  fetchDigests: PropTypes.func,

  userID: PropTypes.number,
  widgetParams: PropTypes.object,
  forStudent: PropTypes.bool,
  showEmptyState: PropTypes.bool,
});

module.exports = WidgetContainer;


// WEBPACK FOOTER //
// ./modules/components/data/widgets/WidgetContainer.js